import { Component, inject } from '@angular/core';
import { Breadcrumb, BreadcrumbService } from '../breadcrumbService';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li
          *ngFor="let crumb of breadcrumbs; let last = last"
          class="breadcrumb-item"
          [class.active]="last"
        >
          <a *ngIf="!last" [routerLink]="crumb.url">{{ crumb.label }}</a>
          <span *ngIf="last">{{ crumb.label }}</span>
        </li>
      </ol>
    </nav>
  `,
  styles: [`
    .breadcrumb {
      display: flex;
      list-style: none;
      padding: 8px 16px;
      background: none;
      border-radius: 8px;
      gap: 8px;
      margin-right: 35px;
    }

    .breadcrumb-item + .breadcrumb-item::before {
      content: '/';
      color: #efebeb;
    }

    .breadcrumb-item a {
      text-decoration: none;
      color: #efebeb;
    }

    .breadcrumb-item.active span {
      color: #fff;
      font-weight: 600;
    }
    @media (max-width: 768px) {
      .breadcrumb {
        margin-right: 0;
      }
    }
  `]
})
export class BreadcrumbComponent {
  private breadcrumbService = inject(BreadcrumbService);
  breadcrumbs: Breadcrumb[] = [];

  ngOnInit() {
    this.breadcrumbService.breadcrumbs.subscribe(crumbs => {
      this.breadcrumbs = crumbs;
    });
  }
}
